<template>
  <div class="es-promo-page">
    <div class="es-detail">
    <div class="es-content"></div>
    <p class="es-intro">
      EWC 电竞世界杯超级福利秀：会员每周投注【EWC电竞世界杯2026】赛事亏损可领救援金；每日累计有效投注达标可参与转盘抽奖，欢迎踊跃参与。
    </p>

    <div class="es-option">
      <ul>
        <li :class="{ on: currentIndex === 0 }" @click="currentIndex = 0">全部</li>
        <li :class="{ on: currentIndex === 1 }" @click="currentIndex = 1">抽奖</li>
      </ul>
      <div @click="openRecord">领取记录</div>
    </div>

    <!-- 优惠卡片：仅救援金，对齐 pgpromo -->
    <div class="es-record" v-show="currentIndex === 0">
      <ul>
        <li v-if="rescueUi" style="background:#FF585866;">
          <div class="top">
            <p>{{ rescueUi.title }}</p>
            <span @click="onDetail">活动详情</span>
          </div>
          <div class="info">
            <div>
              <p>{{ rescueUi.subTitle }}</p>
              <p>{{ rescueUi.startTime }}</p>
            </div>
            <span>{{ rescueUi.reward }}</span>
          </div>
          <div class="desc">
            <p><span>统计时间</span><span>{{ rescueUi.reportTime }}</span></p>
            <p><span>输赢</span><span>{{ rescueUi.totalWinlost }}</span></p>
            <p><span>流水倍数</span><span>{{ rescueUi.betTimes }}</span></p>
          </div>
          <div
            class="btn"
            style="background: linear-gradient(180deg, #FF6A3D 0%, #E12020 100%); color: #fff;"
            @click="applicationPromoAsync(rescueUi)"
          >{{ rescueUi.buttonStatus == 0 ? '' : '已' }}{{ rescueUi.submitType == 0 ? '领取' : '申请' }}</div>
        </li>
      </ul>
    </div>

    <!-- 抽奖：3x3，尺寸按标注 1200×426；高亮切换 Yes/No 切图 -->
    <div class="es-lottery-wrap" v-show="currentIndex === 1">
      <div class="es-lottery-head">
        <p>EWC电竞世界杯流水活动</p>
        <span @click="onLotteryDetail">活动详情</span>
      </div>
      <div class="es-lottery">
      <ul class="play">
        <li
          v-for="(cell, index) in cells"
          :key="'cell-' + index"
          :class="{ select: highlightPos === index, center: cell.type === 'button' }"
        >
          <template v-if="cell.type === 'prize'">
            <div class="prize-stack">
              <img class="prize-img" :src="cell.no" alt="" />
              <img
                class="prize-img prize-on"
                :src="cell.yes"
                alt=""
                v-show="highlightPos === index"
              />
            </div>
          </template>
          <template v-else>
            <p class="chance">你有<em>{{ todayState.count }}</em>次抽奖机会</p>
            <a
              href="javascript:;"
              class="draw-btn"
              :class="{ on: todayState.count > 0, disabled: todayState.count <= 0 }"
              @click="countdown"
            ></a>
          </template>
        </li>
      </ul>
      </div>
    </div>

    <div class="es-rules">
      <p></p>
      <div v-show="currentIndex === 0">
        1.活动期间，仅计算电竞场馆中EWC电竞世界杯2026赛事中的亏损；上周达标会员，领取时间为周二中午12点至周日晚上23:59。<br />
        2.本活动领取的救援金只需在本平台电竞场馆完成6倍流水即可提现。<br />
        3.根据博彩公平有序规则，任何用户或团体以不正常的方式进行投注，本站保留权力在不通知的情况下冻结或关闭相关账户。<br />
        4.此活动只适用于拥有一个账户的会员；同一住址、邮箱、电话、支付方式及 IP 视为同一账户。<br />
        5.为避免文字理解差异，boss保留此活动最终解释权。
      </div>
      <div v-show="currentIndex === 1">
        1.活动期间，活动仅计算电竞场馆中EWC电竞世界杯2026赛事，会员在当日投注并结算的EWC电竞世界杯中累计有效投注额≥1000元即可开启1次转盘，每日上限5次，转盘次数仅限当日使用，次日无效，逾期未开启则视为放弃 奖品说明： ①彩金仅限电竞场馆，1倍流水即可出款； ②实物奖品：请在活动页面点击—>“中奖记录”—>点击“联系客服”—>提供您的地址信息到在线客服即可，奖品一般1-7天到货；实物奖品支持折现，奖金按市场价值八折进行折算，折算彩金完成电竞场馆一倍流水即可提款； ③所有奖品需在活动结束前领取或使用，否则视为放弃。<br />
        2.任何欧洲盘赔率低于 1.75或香港盘 水位低于0.75的投注，以及在同一局游戏中同时投注双方对等盘口的注单或当日注单取消、本金退还、未结算注单、连串过关、平半盘及提前结算等情况，将不计算为有效投注范围内；<br />
        3.根据博彩公平有序规则，任何用户或团体以不正常的方式进行投注，如有风险投注、对赌行为或欺骗方式，本站保留权力在不通知的情况下冻结或关闭相关账户；<br />
        4.此活动只适用于拥有一个账户的会员，每一个住址、每一个电子邮箱地址、每一个电话号码、相同支付方式及 IP 地址视为同一账户，若有违规者，将不享受此红利；<br />
        5.为避免文字理解差异，boss保留此活动最终解释权；
      </div>
    </div>

    <div class="mask1" v-show="showLayer">
      <div class="modal1">
        <span class="close1" @click="showLayer = false"></span>
        <div class="win_c">
          <div class="img" v-if="resultPrize">
            <img :src="resultPrize.yes" alt="" />
            <p>{{ resultPrize.label }}</p>
          </div>
          <p class="win-title">{{ resultTitle }}</p>
          <div class="win_s">{{ resultTip }}</div>
          <a href="javascript:;" class="know-btn" @click="showLayer = false">我知道了</a>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { queryEWCDailyBonusV, ewcAppDailyBonusV, queryEWCESRescuePromoUI, applicationPGPromo } from '../api';

const PRIZES = [
  { key: '8', label: '彩金 8元', yes: require('@/img/espromo/lottery/prize-8-yes.png'), no: require('@/img/espromo/lottery/prize-8-no.png') },
  { key: '38a', label: '彩金 38元', yes: require('@/img/espromo/lottery/prize-38-yes.png'), no: require('@/img/espromo/lottery/prize-38-no.png') },
  { key: '88', label: '彩金 88元', yes: require('@/img/espromo/lottery/prize-88-yes.png'), no: require('@/img/espromo/lottery/prize-88-no.png') },
  { key: '38b', label: '彩金 38元', yes: require('@/img/espromo/lottery/prize-38-yes.png'), no: require('@/img/espromo/lottery/prize-38-no.png') },
  { key: 'keyboard', label: '狼蛛 F87Pro V2 机械键盘', yes: require('@/img/espromo/lottery/prize-keyboard-yes.png'), no: require('@/img/espromo/lottery/prize-keyboard-no.png') },
  { key: '188', label: '彩金 188元', yes: require('@/img/espromo/lottery/prize-168-yes.png'), no: require('@/img/espromo/lottery/prize-168-no.png') },
  { key: '888', label: '彩金 888元', yes: require('@/img/espromo/lottery/prize-888-yes.png'), no: require('@/img/espromo/lottery/prize-888-no.png') },
  { key: 'mouse', label: '外星人 AW610M 鼠标', yes: require('@/img/espromo/lottery/prize-mouse-yes.png'), no: require('@/img/espromo/lottery/prize-mouse-no.png') }
];

// 顺时针格子下标（跳过中心按钮位 4）
const SPIN_ORDER = [0, 1, 2, 5, 8, 7, 6, 3];

export default {
  name: 'EsPromo',
  data() {
    return {
      currentIndex: 0,
      rescueUi: null,
      cells: [],
      prizes: PRIZES,
      highlightPos: -1,
      spinStep: 0,
      seletedPrizeIndex: -1,
      timer: null,
      isOk: true,
      todayState: { count: 0 },
      showLayer: false,
      resultPrize: null,
      resultTitle: '恭喜你',
      resultTip: '奖励已记录，具体以到账为准。实物奖请联系客服领取。'
    };
  },
  created() {
    this.buildCells();
    this.queryEWCESRescuePromoUIAsync();
    this.dailyBonusAsync();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    buildCells() {
      // 3x3：索引 4 为抽奖按钮
      const layout = [
        PRIZES[0], PRIZES[1], PRIZES[2],
        PRIZES[3], null, PRIZES[4],
        PRIZES[5], PRIZES[6], PRIZES[7]
      ];
      this.cells = layout.map((prize) => {
        if (!prize) return { type: 'button' };
        return { type: 'prize', ...prize };
      });
    },
    openRecord() {
      let p = this.$parent;
      while (p && typeof p.openPromoRecord !== 'function' && typeof p.promoShow === 'undefined') {
        p = p.$parent;
      }
      if (p && typeof p.openPromoRecord === 'function') {
        p.openPromoRecord(1);
      } else if (p) {
        if (p.promo) p.promo.recordType = 1;
        p.promoShow = true;
      }
    },
    onDetail() {
      this.openPromoDetail(10);
    },
    onLotteryDetail() {
      this.openPromoDetail(11);
    },
    openPromoDetail(type) {
      let p = this.$parent;
      while (p && typeof p.promo1Show === 'undefined') {
        p = p.$parent;
      }
      if (p) p.promo1Show = type;
    },
    pickPromoCode(ui) {
      if (!ui) return null;
      const v = ui.promoCode != null ? ui.promoCode : ui.PromoCode;
      return v != null && v !== '' ? Number(v) : null;
    },
    async queryEWCESRescuePromoUIAsync() {
      const result = await queryEWCESRescuePromoUI();
      if (result.Result) {
        this.rescueUi = result.Result;
      }
    },
    async applicationPromoAsync(ui) {
      const promoCode = this.pickPromoCode(ui);
      if (promoCode == null || Number.isNaN(promoCode)) {
        this.$toast.fail('优惠编号无效');
        return;
      }
      const result = await applicationPGPromo(promoCode);
      if (!result.Message) {
        this.$toast.success('操作成功');
        this.queryEWCESRescuePromoUIAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    countdown() {
      if (this.isOk === false || this.todayState.count === 0) {
        return;
      }
      this.isOk = false;
      this.seletedPrizeIndex = -1;
      this.spinStep = 0;
      this.highlightPos = SPIN_ORDER[0];
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.spinStep += 1;
        this.highlightPos = SPIN_ORDER[this.spinStep % SPIN_ORDER.length];
        if (
          this.seletedPrizeIndex >= 0 &&
          this.spinStep >= SPIN_ORDER.length * 2 &&
          this.highlightPos === SPIN_ORDER[this.seletedPrizeIndex]
        ) {
          this.reset(true);
        }
      }, 120);
      this.appDailyBonusAsync();
    },
    async dailyBonusAsync() {
      const result = await queryEWCDailyBonusV();
      if (!result.Message) {
        this.todayState.count = result.Result.totalCount;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async appDailyBonusAsync() {
      const result = await ewcAppDailyBonusV();
      if (!result.Message) {
        setTimeout(() => {
          const apiIndex = Number(result.Result.index) || 0;
          this.seletedPrizeIndex = ((apiIndex % SPIN_ORDER.length) + SPIN_ORDER.length) % SPIN_ORDER.length;
        }, 2500);
      } else {
        this.$toast.fail(result.Message);
        this.reset(false);
      }
    },
    reset(successed) {
      clearInterval(this.timer);
      this.timer = null;
      this.isOk = true;
      if (successed === true) {
        const pos = SPIN_ORDER[this.seletedPrizeIndex % SPIN_ORDER.length];
        this.highlightPos = pos;
        const cell = this.cells[pos];
        this.resultPrize = cell && cell.type === 'prize' ? cell : null;
        this.resultTitle = '恭喜你';
        this.resultTip = this.resultPrize
          ? `恭喜抽中${this.resultPrize.label}。彩金将按规则派发；实物请联系客服登记。`
          : '抽奖完成';
        this.showLayer = true;
        if (this.todayState.count > 0) {
          this.todayState.count--;
        }
      } else {
        this.highlightPos = -1;
      }
      this.seletedPrizeIndex = -1;
    }
  }
};
</script>

<style scoped>
.es-promo-page {
  width: 100%;
}

.es-detail {
  width: 100%;
  max-width: 100%;
  margin-top: 0.24rem;
  box-sizing: border-box;
  padding: 3.6rem 0.24rem 0.24rem;
  border-radius: 0.16rem;
  overflow: hidden;
  background-color: #3a0000;
  background-image: url('~@/img/espromo/pc-bg.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
}

.es-detail ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.es-detail a {
  text-decoration: none;
}

.es-content {
  width: 100%;
  height: 0.32rem;
  background: url('~@/img/espromo/title-content.png') no-repeat center center;
  background-size: contain;
}

.es-intro {
  width: 100%;
  text-align: center;
  margin-top: 0.12rem;
  font-size: 0.16rem;
  color: #fff;
  line-height: 1.5;
}

.es-option {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.24rem;
}

.es-option ul {
  display: flex;
  gap: 0.08rem;
  padding: 0.04rem;
  border-radius: 0.12rem;
  background: #791400;
}

.es-option ul li {
  min-width: 1.2rem;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  padding: 0 0.2rem;
  border-radius: 0.1rem;
  font-size: 0.2rem;
  color: #fff;
  cursor: pointer;
  background: transparent;
}

.es-option ul li.on {
  background: linear-gradient(-144.66deg, #FF892F 0%, #FF0000 100%);
  font-weight: bold;
}

.es-option > div {
  display: flex;
  align-items: center;
  height: 0.56rem;
  padding: 0 0.2rem 0 0.48rem;
  border-radius: 0.12rem;
  background: #3A1010;
  font-size: 0.18rem;
  color: #fff;
  cursor: pointer;
  position: relative;
}

.es-option > div::before {
  content: '';
  position: absolute;
  left: 0.14rem;
  width: 0.24rem;
  height: 0.24rem;
  background: url('~@/img/espromo/record.png') no-repeat center center;
  background-size: contain;
}

.es-record {
  margin-top: 0.2rem;
}

.es-record ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.16rem;
}

.es-record ul li {
  width: calc((100% - 0.32rem) / 3);
  box-sizing: border-box;
  border-radius: 0.16rem;
  padding: 0.16rem;
  color: #fff;
}

.es-record ul li .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.es-record ul li .top p {
  display: inline-block;
  padding: 0.04rem 0.12rem;
  border-radius: 0.06rem;
  font-size: 0.16rem;
  background: #FF00008C;
}

.es-record ul li .top span {
  display: flex;
  align-items: center;
  font-size: 0.16rem;
  color: #fff;
  cursor: pointer;
  padding: 0.06rem 0.12rem;
  border-radius: 0.08rem;
  background: #00000033;
}

.es-record ul li .top span::after {
  content: '';
  display: inline-block;
  width: 0.2rem;
  height: 0.2rem;
  margin-left: 0.06rem;
  background: url('~@/img/espromo/info.png') no-repeat center center;
  background-size: contain;
}

.es-record ul li .info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.16rem;
}

.es-record ul li .info div {
  flex: 1;
  min-width: 0;
  padding-right: 0.08rem;
}

.es-record ul li .info div p:first-child {
  font-size: 0.2rem;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-all;
}

.es-record ul li .info div p:last-child {
  margin-top: 0.06rem;
  font-size: 0.14rem;
  color: #FFD36A;
}

.es-record ul li .info > span {
  flex-shrink: 0;
  font-size: 0.4rem;
  font-weight: 700;
  color: #FFD36A;
  line-height: 1;
}

.es-record ul li .desc {
  margin-top: 0.14rem;
}

.es-record ul li .desc p {
  display: flex;
  justify-content: space-between;
  font-size: 0.16rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.85);
}

.es-record ul li .btn {
  margin-top: 0.16rem;
  height: 0.56rem;
  line-height: 0.56rem;
  text-align: center;
  border-radius: 0.28rem;
  font-size: 0.22rem;
  font-weight: 700;
  color: #3A1000;
  cursor: pointer;
}

.es-lottery-wrap {
  width: 12rem;
  margin: 0.2rem auto 0;
}

.es-lottery-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.12rem;
  color: #fff;
}

.es-lottery-head p {
  margin: 0;
  font-size: 0.2rem;
  font-weight: 600;
}

.es-lottery-head span {
  display: flex;
  align-items: center;
  font-size: 0.16rem;
  color: #fff;
  cursor: pointer;
  padding: 0.06rem 0.12rem;
  border-radius: 0.08rem;
  background: #00000033;
}

.es-lottery-head span::after {
  content: '';
  display: inline-block;
  width: 0.2rem;
  height: 0.2rem;
  margin-left: 0.06rem;
  background: url('~@/img/espromo/info.png') no-repeat center center;
  background-size: contain;
}

.es-lottery {
  width: 12rem;
  height: 4.26rem;
  margin: 0;
  box-sizing: border-box;
  border-radius: 0.16rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(
    circle at 50% 50%,
    rgba(255, 0, 0, 0.2) 0%,
    rgba(255, 129, 129, 0.2) 100%
  );
}

.es-lottery .play {
  display: grid;
  grid-template-columns: repeat(3, 2.4rem);
  grid-template-rows: repeat(3, 1.1rem);
  gap: 0.16rem;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}

.es-lottery .play li {
  width: 2.4rem;
  height: 1.1rem;
  position: relative;
  box-sizing: border-box;
  border-radius: 0.08rem;
  overflow: hidden;
  padding: 0;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.es-lottery .play li .prize-stack {
  position: relative;
  width: 2.4rem;
  height: 1.1rem;
}

.es-lottery .play li .prize-img {
  display: block;
  width: 2.4rem;
  height: 1.1rem;
  object-fit: fill;
  pointer-events: none;
}

.es-lottery .play li .prize-img.prize-on {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.es-lottery .play li.select .prize-stack {
  box-shadow: 0 0 0.12rem rgba(255, 210, 80, 0.85);
  border-radius: 0.08rem;
}

.es-lottery .play li.center {
  background: transparent;
}

.es-lottery .play li.center .chance {
  margin: 0 0 0.06rem;
  font-size: 0.18rem;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.es-lottery .play li.center .chance em {
  color: #FFE24A;
  font-style: normal;
  font-weight: 700;
  margin: 0 0.04rem;
}

.es-lottery .draw-btn {
  display: block;
  width: 2.4rem;
  height: 0.6rem;
  background: url('~@/img/espromo/lottery/btn-no.png') no-repeat center center;
  background-size: 100% 100%;
  border: none;
  cursor: pointer;
}

.es-lottery .draw-btn.on {
  background-image: url('~@/img/espromo/lottery/btn-yes.png');
}

.es-lottery .draw-btn.disabled {
  pointer-events: none;
  cursor: default;
}

.es-rules {
  margin-top: 0.28rem;
}

.es-rules > p {
  width: 100%;
  height: 0.32rem;
  background: url('~@/img/espromo/title-rules.png') no-repeat center center;
  background-size: contain;
}

.es-rules > div {
  margin-top: 0.12rem;
  font-size: 0.16rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.85);
}

.mask1 {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal1 {
  width: 4.8rem;
  border-radius: 0.16rem;
  background: #2B1A1A;
  padding: 0.4rem 0.32rem 0.32rem;
  position: relative;
  color: #fff;
}

.close1 {
  position: absolute;
  right: 0.16rem;
  top: 0.16rem;
  width: 0.32rem;
  height: 0.32rem;
  background: url('~@/img/espromo/close.png') no-repeat center center;
  background-size: contain;
  cursor: pointer;
}

.win_c {
  text-align: center;
}

.win_c .img img {
  width: 1.4rem;
  height: 1.4rem;
  object-fit: contain;
}

.win_c .img p {
  margin-top: 0.12rem;
  font-size: 0.22rem;
  font-weight: 700;
  color: #FFD36A;
}

.win-title {
  margin-top: 0.16rem;
  font-size: 0.28rem;
  font-weight: 700;
}

.win_s {
  margin-top: 0.12rem;
  font-size: 0.16rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.75);
}

.know-btn {
  display: block;
  margin: 0.24rem auto 0;
  width: 100%;
  height: 0.64rem;
  line-height: 0.64rem;
  border-radius: 0.12rem;
  background-color: #FF7D01;
  background-image: linear-gradient(180deg, #FFD900 0%, #FF9900 100%);
  color: #773B00;
  font-size: 0.22rem;
  font-weight: 700;
}
</style>
